import { Observable, Subject } from 'rxjs';
import { provideSingleton } from '../di/provide-singleton';

export class LocalStorageService {
  private _didUpdate$: Subject<void> = new Subject<void>();

  public set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
      this._didUpdate$.next(undefined);
    } catch (error) {
      console.error('Error setting item in localStorage', error);
    }
  }

  public get(key: string): string | undefined {
    try {
      const item: string | null = localStorage.getItem(key);
      return item ?? undefined;
    } catch (error) {
      console.error('Error getting item from localStorage', error);
      return undefined;
    }
  }

  public setJson<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      this._didUpdate$.next(undefined);
    } catch (error) {
      console.error('Error setting item in localStorage', error);
    }
  }

  public getJson<T>(key: string): T | undefined {
    try {
      const item: string | null = localStorage.getItem(key);
      return item ? JSON.parse(item) : undefined;
    } catch (error) {
      console.error('Error getting item from localStorage', error);
      return undefined;
    }
  }

  public delete(key: string): void {
    try {
      localStorage.removeItem(key);
      this._didUpdate$.next(undefined);
    } catch (error) {
      console.error('Error deleting item from localStorage', error);
    }
  }

  public didUpdate(): Observable<void> {
    return this._didUpdate$.asObservable();
  }
}

export function provideLocalStorageService(): LocalStorageService {
  return provideSingleton(LocalStorageService, () => new LocalStorageService());
}
